// // Question schema
// const QuestionSchema = new Schema({
//   section: {
//     //Section 1, 2, 3
//     type: String,
//     required: true,
//   },
//   type: {
//     type: String,
//     required: true,
//   }, // Multiple choice ABCD named as 'mcq', multiple small checkboxes true/false named as 'mctf',
//   //short answer named as 'sa'
//   correctAnswer: {
//     type: String, // for mcq: A, B, C, D, for mctf: 1001, 1 is true, 0 is false, based on the order of the options
//     //, for sa: the correct answer exapmle: '-2.5'
//     required: true,
//   },
// });

import { StudentInfo } from '../../model/Student';
import { CourseProps } from '../Home/Course';

// Updated Question interface based on the Mongoose schema
export interface Question {
  questionId: string; // Unique identifier for the question
  section: string; // Section 1, 2, 3
  sectionContent: string; // Section content
  index: number; // Question number
  type: 'mcq' | 'mctf' | 'sa'; // Question types: Multiple choice ('mcq'), Multiple checkboxes true/false ('mctf'), Short answer ('sa')
  correctAnswer: string; // For mcq: A, B, C, D, for mctf: 1001, for sa: example '-2.5'
  question: string;
  questionImage: File | null; // File for the question image or resource
  questionImageUrl: string; // URL to the question image or resource
  explain: string;
  explainImage: File | null; // File for the answer image or resource
  explainImageUrl: string; // URL to the answer image or resource
  reuseContent: string;
  reuseContentImage: File | null;
  reuseContentImageUrl: string;
  questionA: string; // Option A for MCQ and MCTF
  questionB: string; // Option B for MCQ and MCTF
  questionC: string; // Option C for MCQ and MCTF
  questionD: string; // Option D for MCQ and MCTF
  questionAImage: File | null;
  questionAImageUrl: string;
  questionBImage: File | null;
  questionBImageUrl: string;
  questionCImage: File | null;
  questionCImageUrl: string;
  questionDImage: File | null;
  questionDImageUrl: string;
}

export interface SectionType {
  title: string;
  content: string;
  questions: Question[];
}


// Default objects for different types of questions
export const defaultQuestionMCQ: Question = {
  questionId: '', // Example question ID
  section: 'Phần I', // Dynamically provided section
  sectionContent: 'Câu trắc nghiệm nhiều phương án lựa chọn.', // Section content
  index: 1,
  type: 'mcq',
  correctAnswer: '',
  question: 'x',
  questionImageUrl: '',
  explainImageUrl: '',
  questionImage: null,
  explain: 'x',
  explainImage: null,
  questionA: '',
  questionB: '',
  questionC: '',
  questionD: '',
  questionAImage: null,
  questionAImageUrl: '',
  questionBImage: null,
  questionBImageUrl: '',
  questionCImage: null,
  questionCImageUrl: '',
  questionDImage: null,
  questionDImageUrl: '',
  reuseContent: '',
  reuseContentImage: null,
  reuseContentImageUrl: '',
};

export const defaultQuestionMCTF: Question = {
  questionId: '', // Example question ID
  section: 'Phần II', // Dynamically provided section
  sectionContent: 'Câu trắc nghiệm đúng sai.', // Section content
  index: 1, // Example question index
  type: 'mctf', // Default question type: Multiple checkboxes true/false
  correctAnswer: '', // Default correct answer for MCTF (true for all options)\
  question: 'x',
  questionImageUrl: '', // Example question URL
  explainImageUrl: '', // Example answer URL
  questionImage: null, // Default question file
  explainImage: null, // Default answer file
  questionA: '', // Default option A
  questionB: '', // Default option B
  questionC: '', // Default option C
  questionD: '', // Default option D
  explain: 'x', // Default answer
  questionCImage: null,
  questionCImageUrl: '',
  questionDImage: null,
  questionDImageUrl: '',
  questionAImage: null,
  questionAImageUrl: '',
  questionBImage: null,
  questionBImageUrl: '',
  reuseContent: '',
  reuseContentImage: null,
  reuseContentImageUrl: '',
};

export const defaultQuestionSA: Question = {
  questionId: 'sa_001', // Example question ID
  section: 'Phần III', // Dynamically provided section
  sectionContent: 'Câu trắc nghiệm trả lời ngắn. ', // Section content
  index: 1, // Example question index
  type: 'sa', // Default question type: Short answer
  correctAnswer: '', // Default correct answer for SA
  question: 'x',
  questionImageUrl: '', // Example question URL
  explainImageUrl: '', // Example answer URL
  questionImage: null, // Default question file
  explainImage: null, // Default answer file
  questionA: '', // Default option A
  questionB: '', // Default option B
  questionC: '', // Default option C
  questionD: '', // Default option D
  explain: 'x', // Default answer
   questionCImage: null,
  questionCImageUrl: '',
  questionDImage: null,
  questionDImageUrl: '',
  questionAImage: null,
  questionAImageUrl: '',
  questionBImage: null,
  questionBImageUrl: '',
  reuseContent: '',
  reuseContentImage: null,
  reuseContentImageUrl: '',
};

// Default form for THPT Quốc Gia, including 3 sections
// Section 1: 18 questions, multiple choice ABCD
// Section 2: 4 questions, multiple small checkboxes true/false
// Section 3: 6 questions, short answer
export const getDefaultQuestionsForMath: Array<Question> = [
  // Map for Section 1: 12 MCQ questions
  ...Array(12)
    .fill(defaultQuestionMCQ)
    .map((question, index) => ({
      ...question,
      index: index + 1, // Index starts from 1 for Section 1
      section: 'Phần I', // Set section name
      questionId: `mcq_${(index + 1).toString().padStart(3, '0')}`, // Unique question ID
    })),

  // Map for Section 2: 4 MCTF questions
  ...Array(4)
    .fill(defaultQuestionMCTF)
    .map((question, index) => ({
      ...question,
      index: index + 1, // Index starts from 1 for Section 2
      section: 'Phần II', // Set section name,
      questionId: `mctf_${(index + 1).toString().padStart(3, '0')}`, // Unique question ID
    })),

  // Map for Section 3: 6 Short Answer questions
  ...Array(6)
    .fill(defaultQuestionSA)
    .map((question, index) => ({
      ...question,
      index: index + 1, // Index starts from 1 for Section 3
      section: 'Phần III', // Set section name,
      questionId: `sa_${(index + 1).toString().padStart(3, '0')}`, // Unique question ID
    })),
];

export interface VideoLink {
  title: string;
  link: string;
}

export interface Exam {
  examId: string; // Unique identifier for the exam
  courseId: string; // ID of the course to which the exam belongs
  parentFolderId: string; // ID of the parent folder
  parentFolderName?: string; // Name of the parent folder
  title: string; // Title of the exam
  duration: number; // Duration of the exam in minutes
  subject: string; // Subject of the exam
  examTimes: number; // Number of times the exam has been taken
  createdAt?: Date; // Date when the exam was created
  executedAt?: Date; // Date when the exam was executed (optional)
  questions: Array<any>; // Array to hold the questions; replace `any` with the specific type as needed
  createdBy: {
    _id: string;
    name: string;
  };
  isExercise: boolean;
  cannotViewAnswerBeforeFirstExam: boolean;
  onlyForMembers: boolean;
  course?: CourseProps;
  listLinks: VideoLink[];
  pdfLink: string;
  pdfAnswerLink: string;
}

export interface ExamComponentProps {
  exam: Exam;
  handleOpenDialog: (id: string) => void;
}

export interface Result {
  studentId: string; // ID of the student who took the exam
  student?: StudentInfo;
  score?: number; // Score of the student
  examId: string;
  answers: {
    questionId: string;
    answer: string; // 'A', 'B', 'C', 'D' for MCQ, '1001' for MCTF, '-2.5' for SA
    check?: boolean; // Check if the answer is correct
  }[];
  completeTime: number; // Time taken to complete the exam in seconds
  createdAt?: Date;
  exam?: Exam;
  rank?: string; // 7/100
  otherResults?: Result[];
}

export const defaultResult: Result = {
  studentId: '', // ID of the student who took the exam
  examId: '', // ID of the exam
  answers: [], // Array of answers
  completeTime: 0, // Time taken to complete the exam
};

export const defaultExam: Exam = {
  examId: '', // This will be generated by the server or can be set manually if needed
  courseId: '', // This will be provided dynamically
  parentFolderId: '', // This will be provided dynamically
  title: 'New Exam', // Default title
  duration: 60, // Default duration in minutes
  subject: 'General', // Default subject
  examTimes: 0, // Default number of times the exam has been taken
  createdAt: new Date(), // Default creation date
  executedAt: undefined, // Default execution date
  questions: [], // Default questions array
  createdBy: {
    _id: '', // ID of the user who created the exam
    name: '', // Full name of the user who created the exam
  },
  isExercise: false, // Default isExercise value
  onlyForMembers: true, // Default onlyForMembers value
  cannotViewAnswerBeforeFirstExam: false,
  listLinks: [],
  pdfLink: '',
  pdfAnswerLink: '',
};

export interface ExamInput {
  title: string;
  duration: string;
  subject: string;
  executedAt: Date | null;
  questions: Array<Question>;
  isExercise: boolean;
  onlyForMembers: boolean;
  isEdittingQuestion: boolean;
  listLinks: VideoLink[];
  pdfLink: string;
  pdfAnswerLink: string;
  cannotViewAnswerBeforeFirstExam: boolean;
}

export interface ExammingPageProps {}

export interface CreateExamPageProps {
  exam: Exam;
  mode?: 'view' | 'edit' | 'create';
  examInput: ExamInput;
  setExamInput: React.Dispatch<React.SetStateAction<ExamInput>>;
  isTeacher: boolean;
  isNotOnDialog: boolean;
  result: Result | null;
  sortedResults?: Result[];
  isDataAllFetched: boolean;
  onClosed?: () => void;
  showResultByTime: boolean;
  handleSave: () => void;
  loadingButton: boolean;
  isDataFilled: boolean;
  progress: number;
}

export const defaultExamInput: CreateExamPageProps['examInput'] = {
  title: '',
  duration: '60',
  subject: 'Math',
  executedAt: new Date(),
  questions: [],
  isExercise: false,
  onlyForMembers: false,
  isEdittingQuestion: false,
  listLinks: [],
  pdfLink: '',
  pdfAnswerLink: '',
  cannotViewAnswerBeforeFirstExam: false,
};
